import {
  CTA,
  styled,
  Text,
  TextTag,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import {ShareIOS} from '@volkswagen-onehub/icons-core';
import React, { useContext } from 'react';
import { useFocusLayer } from '../../Layers/use-focus-layer';
import { FocusLayerSizeV2 } from '@volkswagen-onehub/layer-manager';
import { LayerContext } from '../../Layers/layer-context';
import ShareListModal from './ShareListModal';
import { getTranslations } from '../../translations';

const ShareListContainer = styled.div`
  grid-column: 2 / 3;
  grid-row: 1 / 2;
`;

export default () => {
  const {closeLayer} = useContext(LayerContext);

  const {labels} = getTranslations();

  const openShareListLayer = useFocusLayer('share-list-layer', {
    size: FocusLayerSizeV2.A,
    onClose: () => closeLayer('share-list-layer'),
  });

  const onShareList = () => {
    openShareListLayer((close) => <ShareListModal close={close} />);
  }
  return (
    <ShareListContainer>
      <CTA
        tag="button"
        icon={<ShareIOS ariaHidden />}
        emphasis="tertiary"
        onClick={onShareList}
      >
        <Text tag={TextTag.span} appearance={TokenTextAppearance.label200} bold>{labels.share.cta}</Text>
      </CTA>
    </ShareListContainer>
  );
};
